// extracted by mini-css-extract-plugin
export default {"primaryColor":"#354760","white":"#fff","checkbox":"styles_checkbox__kmXDo"};